import { CartDTO, CartResponse, CreateWaitingListCartDTO } from '../types';
import { axiosInstance, endpoints } from '../utils/axios';

export async function createCart(
  eventId: number,
  payload: CartDTO,
  promoter?: string
): Promise<CartResponse> {
  let url = endpoints.cart.createCart(eventId);

  if (promoter) {
    url = `${url}?promoter=${promoter}`;
  }

  const response = await axiosInstance.post<CartResponse>(url, payload);
  return response.data;
}

export async function updateCart(
  eventId: number,
  id: number,
  payload: CartDTO,
  promoter?: string
): Promise<CartResponse> {
  let url = endpoints.cart.updateCart(eventId, id);

  if (promoter) {
    url = `${url}?promoter=${promoter}`;
  }

  const response = await axiosInstance.put<CartResponse>(url, payload);
  return response.data;
}

export async function getCart(cartId: number): Promise<CartResponse> {
  const url = endpoints.cart.getCart(`${cartId}`);
  const response = await axiosInstance.get<CartResponse>(url);
  return response.data;
}

export async function createWaitingListCart(
  eventId: number,
  payload: CreateWaitingListCartDTO,
  promoter?: string
): Promise<CartResponse> {
  let url = endpoints.cart.createWaitingListCart(eventId);

  if (promoter) {
    url = `${url}?promoter=${promoter}`;
  }

  const response = await axiosInstance.post<CartResponse>(url, payload);
  return response.data;
}
